export default __webpack_public_path__ + "static/media/Quiken_Webp.75b39411.webp";